import React, { memo } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

import { ListView, KanbanView, CalendarView, AccessModule } from 'modules'
import { ErrorScreen } from 'screens'
import {PageHeader} from './PageHeader'

import { pageContext } from 'context'
import * as actionCreators from 'store/actions'

const Container = styled.div`
    width: 100%;
    height: 100%;
    flex-grow: 4;
    display: flex;
    flex-direction: column;
    min-height: ${props => props.access ? '200vh' : 'calc(100vh - 2.5rem)'};
    overflow-x: hidden;
`

const PageScreen = props => {
    const user = useSelector(state => state.auth.user, (newValue) => (newValue['activePageID'] === user['activePageID']))
    const data = useSelector(state => state.db.present.data && state.db.present.data.toJS(), (newValue) => (newValue.pages[user['activePageID']] === data.pages[user['activePageID']]))
    const page = data['pages'][user['activePageID']]

    let view;
    let viewType;
    let error = false;
    if(!Object.keys(data['pages']).includes(user['activePageID'])){
        view = <ErrorScreen error='page-not-found'/>
        error = true
    } else if(page['createdBy'] === user['uid'] || page['sharedWidth'].includes(user['uid'])){
        viewType = page['page_view']
        error = false
        switch (viewType) {
            case pageContext.VIEWS.LIST_VIEW:
                view = <ListView/>
                break
            case pageContext.VIEWS.KANBAN_VIEW:
                view = <KanbanView/>
                break
            case pageContext.VIEWS.CALENDAR_VIEW:
                view = <CalendarView/>
                break
        }
    } else if (page['createdBy'] !== user['uid'] || !page['sharedWith'].includes(user['uid'])) {
        view = <ErrorScreen error='no-access'/>
        error = true
    } else {
        view = <ErrorScreen/>
        error = true
    }

    return (
        <Container>
            {!error && <PageHeader/>}
            {view}
        </Container>
    )
}

export default memo(PageScreen)